module.exports = __webpack_public_path__ + "/assets/st.png";


/*****************
 ** WEBPACK FOOTER
 ** ../src/dash/front/styles/images/st.png
 ** module id = 1713
 ** module chunks = 0
 **/